export const en = {
  nav: {
    parking: 'Parking',
    prices: 'Prices',
    contact: 'Contact',
    faq: 'FAQ',
    directions: 'Directions',
    book: 'Book',
    bookNow: 'Book now',
    selectLanguage: 'Select language',
  },
  hero: {
    headline: 'Stress-free valet parking',
    headlineLine2: 'at Frankfurt Airport',
    subtitle: 'Your car on our privately rented parking spaces \u2013 secure,',
    subtitleLine2: 'insured and handed over right at the terminal.',
    arrivalLabel: 'When do you arrive?',
    departureLabel: 'When do you depart?',
    bookingNote: 'Booking possible from 24h in advance',
    ctaButton: 'Book parking now',
  },
  howItWorks: {
    title: '4 steps to the terminal',
    subtitle: 'Our Valet-Service is designed for maximum efficiency and comfort.',
    step1: { category: 'Booking', title: 'Book online', description: 'Reserve your parking space conveniently online. Choose your travel times and additional options.' },
    step2: { category: 'Handover', title: 'Handover at terminal', description: 'Drive directly to the departure terminal. Our staff is already waiting for your vehicle.' },
    step3: { category: 'Travel', title: 'Safely parked', description: 'While you travel, your car is safely insured on our paved parking spaces.' },
    step4: { category: 'Return', title: 'Direct return', description: 'On arrival, your vehicle is ready at the terminal on time. Simply get in and drive off.' },
  },
  awards: {
    title: 'Smart parking for smart travelers',
    subtitle: 'Valet parking at Frankfurt Airport \u2013 Maximum security, minimum price.',
    savings: 'Savings',
    priceAdvantage: 'Up to 50% price advantage',
    cheaperThanTerminal: 'Cheaper than parking directly at the terminal.',
    terminalParking: 'Terminal parking',
    excellentService: 'Excellent service',
    topRatings: 'Top ratings from real customers.',
    stars: '4.9/5 Stars',
    bestPriceGuarantee: 'Best price guarantee',
    startingFrom: 'Starting from',
    forUpTo8Days: 'for up to 8 days',
    calculatePrice: 'Calculate price now',
    professionalValet: 'Professional valet parking',
    vehicleSafeHands: 'Your vehicle is in safe hands with us. We guarantee the highest security standards.',
    insuredByLaw: 'Insured according to legal regulations',
    pavedParking: 'Paved parking area',
    ownRentedSpaces: 'Privately rented parking spaces',
  },
  security: {
    badge: 'Security & Service',
    title: 'Your vehicle in safe hands',
    p1: 'If you would like to use our Valet-Service, we offer you convenient and worry-free comfort.',
    p2: 'We pick up your vehicle directly at',
    p2bold: 'Terminal 1 or 2',
    p2rest: 'of Frankfurt Airport and park it safely on our privately rented, paved parking spaces. These are located about 9 km from the airport.',
    p3: 'With this short distance to Frankfurt Airport, we can offer you a fast and efficient service, so your car is safely parked while you travel.',
    insuredByLaw: 'Insured according to legal regulations',
    pavedParking: 'Paved parking area',
    only9km: 'Only 9km to the terminal',
    distanceBadge: '9km to terminal',
    locationLabel: 'The location',
    locationTitle: 'Security grounds Hattersheim',
    locationDesc: 'Safely parked on our privately rented, paved parking spaces. Accessible only to staff.',
    securityLabel: 'Security',
    securityTitle: 'Fully secured',
    securityDesc: 'Your vehicle is in safe hands on our private, paved parking lot.',
    handoverLabel: 'Terminal handover',
    handoverTitle: 'Right at departure',
    handoverDesc: 'Direct pickup at Terminal 1 or 2. Efficient and without delay, you start your journey relaxed.',
    terminal1Active: 'Terminal 1 Active',
    terminal2Active: 'Terminal 2 Active',
  },
  contactSection: {
    badge: 'Contact & Directions',
    title: 'We are here for you',
    subtitle: 'Your direct line to us. Parking, Valet-Service and support \u2013 all in one place.',
    support: 'Support',
    customerService: 'Customer service',
    copied: 'Copied!',
    location: 'Location',
    parkingAddress: 'Parking address',
    planRoute: 'Plan route',
    nowOpen: 'Open now',
    closed: 'Closed',
    openingHours: 'Opening hours (Valet)',
    hours: '07:00 \u2013 17:00',
    dailyOpen: 'Open daily',
  },
  faqSection: {
    badge: 'GOOD TO KNOW',
    title: 'Frequently asked questions',
    subtitle: 'Here you will find answers about the parking process, security and prices.',
    stillQuestions: 'Still have questions?',
    weHelpGladly: 'We are happy to help.',
    notFound: 'Didn\u2019t find what you were looking for? Our support team is here for you.',
    contactUs: 'Contact us',
    q1: 'Where is my car parked?',
    a1: 'On our privately rented parking spaces in Hattersheim. Your vehicle is not on public roads, but on a secured private property.',
    q2: 'What happens with night arrival?',
    a2: 'Outside our core hours (07:00-17:00) a night surcharge of \u20ac80 applies. Please take this into account when booking and inform us of your arrival time in advance.',
    q3: 'How does the handover work?',
    a3: 'You drive directly to Terminal 1 or 2. Our valet staff is waiting for you to pick up the vehicle. You will receive the exact details with your booking confirmation.',
  },
  bookingCTA: {
    badge: 'Get started',
    title: 'Book your parking space',
    subtitle: 'Choose your travel dates and secure your spot with Valet-Service.',
    arrivalLabel: 'When do you arrive?',
    departureLabel: 'When do you depart?',
    bookingNote: 'Booking only possible from 24 hours in advance',
    daysParking: '{days} day{plural} parking',
    valetIncluded: 'Valet-Service included',
    days1to8: '1-8 days: \u20ac99',
    ctaButton: 'Book parking now',
    freeCancellation: 'Free cancellation',
    valetService: 'Valet-Service',
  },
  footer: {
    description: 'Stress-free valet parking at Frankfurt Airport. Secure, insured and right at the terminal.',
    service: 'Service',
    parking: 'Parking',
    prices: 'Prices',
    directions: 'Directions',
    cancelBooking: 'Cancel booking',
    company: 'Company',
    contact: 'Contact',
    faq: 'FAQ',
    home: 'Home',
    contactTitle: 'Contact',
    locationInfo: 'Hattersheim (Frankfurt Airport)',
    hours: 'Mon-Sun, 07:00 - 17:00',
    copyright: '\u00a9 {year} Park-Box Frankfurt. All rights reserved.',
    imprint: 'Imprint',
    privacy: 'Privacy Policy',
    terms: 'Terms',
  },
  booking: {
    pageTitle: 'Book parking online',
    pageSubtitle: 'Secure your parking space in just a few steps.',
    step1Label: 'Travel dates',
    step2Label: 'Flight data',
    step3Label: 'Vehicle',
    step4Label: 'Contact',
    step5Label: 'Extras',
    travelDates: 'Travel dates',
    arrivalLabel: 'When do you arrive?',
    departureLabel: 'When do you depart?',
    bookingNote24h: 'Booking only possible from 24 hours in advance',
    travelPeriod: 'Travel period: {days} day{plural} selected',
    continueToFlightData: 'Continue to flight data for your price overview',
    flightData: 'Flight data',
    flightNumberOutbound: 'Flight number outbound',
    flightNumberReturn: 'Flight number return',
    optional: '(optional)',
    arrivalTimeLabel: 'Arrival time at airport *',
    departureTimeLabel: 'Landing time return flight *',
    nightSurchargeApplied: 'Night surcharge (+\u20ac{amount}) will be charged',
    bookingNotPossible: 'Booking not possible',
    booking24hRule: 'Booking is only possible from 24 hours in advance. Please choose a later date.',
    flightDataInfo: 'Flight data helps us with pickup and planning. Times refer to handover/pickup at the terminal.',
    nightSurchargeInfo: 'Night surcharge information',
    noNightSurcharge: 'No night surcharge',
    nightSurchargeTime: 'Before 07:00 or after 17:00:',
    nightSurchargeAmount: '+\u20ac{amount} night surcharge',
    timeRange: '07:00 \u2013 17:00:',
    vehicleData: 'Vehicle data',
    vehicleBrand: 'Vehicle brand *',
    vehicleModel: 'Model *',
    licensePlate: 'License plate *',
    vehicleColor: 'Vehicle color *',
    contactData: 'Contact data',
    emailLanguageLabel: 'Language for email confirmation',
    bookAs: 'I book as *',
    privateCustomer: 'Private customer',
    privatePerson: 'Individual',
    businessCustomer: 'Business customer',
    businessCompany: 'Company',
    companyName: 'Company name *',
    vatId: 'VAT ID',
    salutation: 'Salutation *',
    pleaseSelect: 'Please select',
    mr: 'Mr.',
    mrs: 'Mrs.',
    diverse: 'Other',
    phone: 'Phone / Mobile *',
    firstName: 'First name *',
    lastName: 'Last name *',
    streetAndNumber: 'Street & No. *',
    zipCode: 'Postal code *',
    city: 'City *',
    email: 'Email *',
    emailRepeat: 'Repeat email *',
    emailMismatch: 'Email addresses do not match',
    dataSecure: 'Your data is securely transmitted and used only for booking processing.',
    extras: 'Additional services',
    flightClass: 'Flight class *',
    economy: 'Economy',
    businessFirstClass: 'Business / First Class',
    chargingService: 'E-charging service',
    chargingDesc: 'Charging service for your electric car (electricity costs billed separately)',
    cancellationProtection: 'Cancellation protection',
    cancellationProtectionDesc: 'Cancel free of charge even within 24h before arrival',
    luggage: 'Your luggage',
    luggageNone: 'Not needed',
    luggageCheckin: 'Check-in suitcase',
    luggageHandOnly: 'Hand luggage only',
    paymentMethod: 'Payment method',
    paymentCash: 'Payment: Cash on site',
    paymentCashDesc: 'Payment upon vehicle handover',
    paymentPaypal: 'Payment: PayPal',
    paymentPaypalDesc: 'Pay in advance via PayPal to our address (+€5 fee).',
    paypalFee: 'PayPal fee',
    paypalAddressLabel: 'PayPal address',
    paymentReferenceHint: 'After booking, please use your booking number as the payment reference.',
    bookingSummary: 'Your booking summary',
    arrival: 'Arrival',
    departure: 'Departure',
    flightDataSection: 'Flight data',
    arrivalAtAirport: 'Arrival at airport',
    landingTimeReturn: 'Landing time return',
    flight: 'Flight',
    vehicle: 'Vehicle',
    brand: 'Brand',
    model: 'Model',
    color: 'Color',
    contactDataSection: 'Contact data',
    priceOverview: 'Price overview',
    parkingDays: 'Parking ({days} {daysLabel})',
    day: 'day',
    days: 'days',
    nightSurchargeArrival: 'Night surcharge vehicle pickup',
    nightSurchargeDeparture: 'Night surcharge vehicle return',
    valetServiceIncl: 'Valet-Service',
    included: 'Included',
    totalPrice: 'Total price',
    cancellationConditions: 'Cancellation conditions',
    moreThan24h: 'More than 24h before arrival:',
    freeCancellation: 'Free cancellation',
    within24h: 'Within 24h before arrival:',
    fee100: '100% fee',
    withProtection: 'With cancellation protection (+\u20ac5):',
    alwaysFree: 'Always free',
    callImportant: 'Important: Call 60 minutes before arrival!',
    remarks: 'Remarks',
    remarksPlaceholder: 'Do you have special requests or notes? e.g. type of bulky luggage, child seats, etc.',
    other: 'Other',
    leaveKeys: 'Leave car keys with the parking provider during the trip',
    mandatoryValet: '(Required for Valet-Service)',
    acceptTerms: 'I have read the',
    termsLink: 'Terms & Conditions',
    and: 'and the',
    privacyLink: 'Privacy Policy',
    acceptTermsEnd: 'and accept them. *',
    pleaseAcceptTerms: 'Please accept the terms to continue.',
    back: 'Back',
    next: 'Next',
    submitting: 'Creating booking...',
    submitButton: 'Book now (binding)',
    submitError: 'Error creating the booking',
    errorGeneric: 'An error occurred. Please try again.',
    errorCreateBooking: 'Booking could not be created',
    sslEncrypted: 'SSL encrypted',
    customerServiceBadge: 'Customer service',
  },
  confirmation: {
    bookingSuccess: 'Booking successful!',
    thankYou: 'Thank you for your booking with Park-Box Frankfurt',
    bookingNumber: 'Your booking number',
    callImportant: 'Important: Call 60 minutes in advance!',
    callDesc: 'Please call us at least 60 minutes before your arrival at the airport.',
    confirmationSent: 'Confirmation sent',
    emailSentTo: 'An email was sent to',
    emailSentEnd: '.',
    travelDates: 'Travel dates',
    arrival: 'Arrival',
    departure: 'Departure',
    vehicle: 'Vehicle',
    type: 'Type',
    licensePlate: 'License plate',
    color: 'Color',
    contactData: 'Contact data',
    priceOverview: 'Price overview',
    parkingDuration: 'Parking duration',
    extras: 'Extras',
    nightSurchargeArrival: 'Night surcharge arrival',
    nightSurchargeDeparture: 'Night surcharge departure',
    valetService: 'Valet-Service',
    included: 'Included',
    totalPrice: 'Total price',
    paymentMethod: 'Payment method',
    paymentCash: 'Payment: Cash on site',
    paymentPaypal: 'Payment: PayPal',
    paymentPaypalDesc: 'Please send the full amount via PayPal to this address.',
    paypalFee: 'PayPal fee',
    paymentReference: 'Reference',
    nextSteps: 'What happens next:',
    step1: '60 minutes before arrival at the airport, call us:',
    step2: 'Drive to Frankfurt Airport, Terminal 1 or 2.',
    step3: 'Meeting point: Departure area past the barriers.',
    step4: 'On your return: Call us as soon as you have your luggage.',
    step5: 'Return at the departure area.',
    questionsContact: 'For questions, reach us at:',
    needToCancel: 'Need to cancel?',
    cancelBooking: 'Cancel booking',
    print: 'Print',
    toHomepage: 'To homepage',
    noBookingFound: 'No booking found',
    noBookingDesc: 'No booking data was found. The page may have been accessed directly.',
    newBooking: 'Start new booking',
  },
  cancellation: {
    title: 'Cancel booking',
    subtitle: 'Enter your booking details to request a cancellation',
    bookingNumber: 'Booking number',
    emailAddress: 'Email address',
    emailPlaceholder: 'Your email from the booking',
    searchBooking: 'Search booking',
    searching: 'Searching...',
    error: 'Error',
    pleaseEnterBoth: 'Please enter booking number and email',
    alreadyCancelled: 'Already cancelled',
    alreadyCancelledDesc: 'This booking has already been cancelled.',
    cancellationRequested: 'Cancellation already requested',
    cancellationRequestedDesc: 'You requested a cancellation on {date}. We will contact you.',
    yourBooking: 'Your booking',
    arrival: 'Arrival',
    departure: 'Departure',
    vehicle: 'Vehicle',
    totalPrice: 'Total price',
    cancellationConditions: 'Cancellation conditions',
    moreThan24h: 'More than 24h before arrival:',
    freeCancellation: 'Free cancellation',
    lessThan24hWith: 'Less than 24h WITH cancellation protection:',
    lessThan24hWithout: 'Less than 24h WITHOUT cancellation protection:',
    fee100: '100% fee',
    freeCancellationMore24h: 'Free cancellation possible (more than 24 hours before arrival)',
    freeCancellationProtection: 'Free cancellation possible (cancellation protection booked)',
    paidCancellation: 'Less than 24 hours before arrival, without protection - 100% fee',
    protectionIncluded: 'Cancellation protection is included in your booking',
    reasonLabel: 'Reason for cancellation (optional)',
    reasonPlaceholder: 'e.g. Flight was cancelled',
    requestCancellation: 'Request cancellation',
    cancelNowFree: 'Cancel now for free',
    sendingRequest: 'Sending...',
    cancelling: 'Cancelling...',
    afterSendNote: 'After submitting, our team will review your request.',
    immediateNote: 'The cancellation will be processed immediately.',
    questionsContact: 'For questions, reach us at:',
    orByEmail: 'or by email at info@parkboxfrankfurt.com',
    bookingCancelled: 'Booking cancelled!',
    cancelledSuccessfully: 'Your booking has been successfully cancelled',
    freeCancellationDone: 'Free cancellation',
    cancelledFreeDesc: 'Your booking has been cancelled free of charge. You will receive a confirmation by email.',
    planNewTrip: 'Planning a new trip?',
    newBooking: 'Create new booking',
    toHomepage: 'To homepage',
    requestSubmitted: 'Request submitted',
    requestBeingProcessed: 'Your cancellation request is being processed',
    importantNote: 'Important note',
    paidNoteDesc: 'As your arrival is within 24 hours and no cancellation protection was booked, a cancellation fee may apply according to our terms.',
    whatHappensNext: 'What happens next?',
    teamWillReview: 'Our team will review your request and get back to you shortly.',
  },
  prices: {
    badge: 'Transparency Guarantee',
    title1: 'Simple Prices.',
    title2: 'No Surprises.',
    subtitle: 'Premium Valet-Service from \u20ac99 for up to 8 days. Secure, insured and right at the terminal.',
    valetInclusiveTitle: 'Valet Included',
    valetInclusiveDesc: 'Vehicle handover right at the terminal. No transfer needed.',
    insuredTitle: 'Insured',
    insuredDesc: 'Your vehicle is insured according to legal regulations.',
    coreHoursLabel: 'Core Valet-Service hours',
    coreHoursValue: '07:00 \u2013 17:00',
    nightRateNote: 'Outside these hours our night rate applies (+\u20ac80).',
    calcTitle: 'Calculate your costs.',
    calcDesc: 'Our model is simple. You pay per day. If you arrive or depart at night, a one-time surcharge applies to fairly compensate our staff.',
    calcDays1to8: '1-8 days: <strong>\u20ac99</strong>',
    calcFrom9Days: 'From 9 days: <strong>at current daily rate</strong>',
    calcNightSurcharge: 'Night surcharge (17:01 - 06:59): <strong>flat \u20ac80</strong>',
    receiptLabel: 'Cost estimate',
    arrivalLabel: 'Arrival',
    departureLabel: 'Departure',
    nightSurchargeWarning: 'Night surcharge +\u20ac80',
    parkingDurationLabel: 'Parking duration: ',
    daysSingular: 'day',
    daysPlural: 'days',
    parkingSlot: 'Parking',
    valetServiceLine: 'Valet-Service',
    valetServiceFree: '\u20ac0.00 (Included)',
    nightSurchargeArrival: 'Night surcharge arrival',
    nightSurchargeDeparture: 'Night surcharge departure',
    totalLabel: 'Total',
    bookNow: 'Book now',
    addonsTitle: 'Additional Services',
    addonsSubtitle: 'Optionally bookable for maximum comfort.',
    addonEvTitle: 'EV Charging Service',
    addonEvDesc: 'Charging service for your electric vehicle. Electricity costs are billed separately based on consumption.',
    addonCancelTitle: 'Cancellation Protection',
    addonCancelDesc: 'Full flexibility. Free cancellation or rebooking until the last minute before arrival.',
    comparisonTitle: 'Why pay more?',
    comparisonDesc: 'Enjoy valet luxury at the price of standard parking. We optimize our processes to offer you the best price on the market.',
    comparisonSaving: 'You save ~60% compared to terminal parking',
    comparisonTerminal: 'Terminal',
    faqTitle: 'Frequently Asked Questions About Prices',
    faqQ1: 'How is the parking duration calculated?',
    faqA1: 'We charge per calendar day. Every started day counts as a full day. This guarantees you maximum flexibility with slight delays on the departure day.',
    faqQ2: 'When exactly does the night surcharge apply?',
    faqA2: 'The night surcharge of \u20ac80.00 applies as a flat rate when your vehicle handover (arrival) or vehicle return (departure) falls within the period between 17:01 and 06:59.',
    faqQ3: 'How can I pay?',
    faqA3: 'Payment can be made either in cash upon vehicle handover or in advance via PayPal to info@parkboxfrankfurt.com. An online booking in advance is still required.',
    faqQ4: 'Are changes to the booking free of charge?',
    faqA4: 'With our optional cancellation protection (\u20ac5.00) you can cancel or rebook free of charge until the last minute. Without this protection, our regular cancellation conditions apply.',
  },
  parkingPage: {
    breadcrumbHome: 'Home',
    breadcrumbParking: 'Parking & Location',
    heroTitle: 'Security for Your Vehicle',
    heroSubtitle: 'Our privately rented parking spaces in Hattersheim. Only 10 km from the terminal \u2013 including Valet-Service.',
    locationBadge: 'Location & Security',
    locationTitle: 'Protected parking in Hattersheim',
    locationDesc: 'No searching for parking, no tight parking garages. Your vehicle stands on our privately rented parking spaces at S\u00fcdring 10. Illuminated and accessible only to our staff.',
    locationFeature1: '10 km to the airport (approx. 12 min drive for our team)',
    locationFeature2: 'Private grounds',
    locationFeature3: 'Asphalted & paved surfaces',
    locationImgAlt: 'Secure parking lot Hattersheim',
    valetProcessTitle: 'How the Valet-Service Works',
    valetProcessSubtitle: 'Simple, fast and comfortable.',
    tabDeparture: 'Departure',
    tabReturn: 'Return',
    depStep1Title: 'Complete booking online',
    depStep1Desc: 'Reserve your parking space conveniently via our website. You will receive an immediate confirmation.',
    depStep2Title: 'Drive to the terminal',
    depStep2Desc: 'Drive directly to departure terminal 1 or 2. Our staff is already waiting for you.',
    depStep3Title: 'Vehicle handover',
    depStep3Desc: 'After a brief check, you hand over the key. We park your car safely in Hattersheim.',
    retStep1Title: 'Landing in Frankfurt',
    retStep1Desc: 'Welcome back! As soon as you have landed, please switch on your mobile phone.',
    retStep2Title: 'Quick call',
    retStep2Desc: 'Call us as soon as you have your luggage. We will set off immediately.',
    retStep3Title: 'Return at the terminal',
    retStep3Desc: 'Your car is already waiting for you at the agreed exit. Have a safe trip home!',
    valetImgAlt: 'Valet-Service handover',
    conditionsTitle: 'Conditions & Details',
    condPriceTitle: 'From \u20ac99 for 8 days',
    condPriceDesc: 'Transparent pricing with no hidden costs.',
    condPriceValetIncl: 'Valet-Service included',
    condInsuredTitle: 'Insured',
    condInsuredDesc: 'Your vehicle is insured according to legal regulations.',
    condHoursTitle: '07:00 - 17:00',
    condHoursDesc: 'Core hours for pickup & return without surcharge.',
    condNightNote: 'Night surcharge (17:01-06:59): \u20ac80',
    addressTitle: 'Where Your Vehicle is Parked',
    mapTitle: 'Park-Box Frankfurt location map',
    callUs: 'Call us',
    writeUs: 'Write to us',
  },
  contactPage: {
    breadcrumbHome: 'Home',
    breadcrumbContact: 'Contact',
    title: 'We are here for you',
    subtitle: 'Do you have questions about our Valet-Service or your parking space? Here you will find all contact options and our location in Hattersheim.',
    customerService: 'Customer service',
    customerServiceDesc: 'For inquiries about existing bookings or general information.',
    parkingAddress: 'Parking address',
    parkingAddressDesc: 'This is where our secured facility is located.',
    planRoute: 'Plan route',
    bookParking: 'Book parking',
    bookParkingDesc: 'Would you like to reserve a parking space?',
    bookParkingInfo: 'Please use our online form for parking reservations.',
    goToBooking: 'Go to booking',
    yourWayToUs: 'Your way to us',
    yourWayToUsDesc: 'Our parking lot at S\u00fcdring 10, Hattersheim, is strategically located and provides quick access to the terminal.',
    openOnGoogleMaps: 'Open on Google Maps',
    faqTitle: 'Frequently asked questions',
    faq1Question: 'Where exactly do I hand over my vehicle?',
    faq1Answer: 'The handover takes place directly at Terminal 1 or 2 of Frankfurt Airport. Detailed information about the meeting point and procedure will be provided in your booking confirmation.',
    faq2Question: 'How short-notice can I book?',
    faq2Answer: 'You can book your parking space up to 24 hours before departure conveniently via our online form. For more urgent requests, please contact us by phone.',
    faq3Question: 'What happens if my flight is delayed?',
    faq3Answer: 'No worries. We monitor flight times. However, please call us briefly at the service number provided as soon as you have landed, so we can optimally coordinate the return of your vehicle.',
  },
  anfahrtPage: {
    breadcrumbHome: 'Home',
    breadcrumbAnfahrt: 'Directions',
    title: 'Directions & Location',
    subtitle: 'Your way to our secured parking lot in Hattersheim and information about vehicle handover at Frankfurt Airport.',
    ourLocation: 'Our location',
    customerService: 'Customer service',
    customerServiceDesc: 'For inquiries about existing bookings or general information.',
    reachableDuringHours: 'Available during our opening hours',
    planRouteGoogleMaps: 'Plan route on Google Maps',
    openMap: 'Open map',
    terminalHandoverTitle: 'Vehicle handover at the terminal',
    terminalHandoverDesc: 'We pick up your vehicle directly at the departure terminal. Please select your terminal for detailed instructions.',
    departureTerminal1: 'Departure Terminal 1',
    terminal1Desc: 'Please drive directly to the <strong>departure level Terminal 1</strong>. Our valet driver will be waiting for you at the agreed meeting point (usually Door C) after your phone call.',
    navToTerminal1: 'Navigate to Terminal 1',
    departureTerminal2: 'Departure Terminal 2',
    terminal2Desc: 'For flights from Terminal 2, we meet directly at the <strong>terminal forecourt (Departure)</strong>. Exact coordinates and the pickup point will be provided upon booking.',
    navToTerminal2: 'Navigate to Terminal 2',
    arrivalProcessTitle: 'How the arrival works',
    arrivalProcessSubtitle: 'Simple process for a stress-free start to your vacation.',
    step1Title: '30 min before arrival',
    step1Desc: 'Please call us 30 minutes before your arrival at',
    step1DescEnd: '.',
    step2Title: 'Meeting point terminal',
    step2Desc: 'Drive directly to the agreed terminal (1 or 2) at Frankfurt Airport. No searching for parking needed.',
    step3Title: 'Vehicle handover',
    step3Desc: 'Our staff member (identifiable by Park-Box Frankfurt clothing) will take your vehicle and perform a brief check.',
    step4Title: 'Safe parking',
    step4Desc: 'Your car will be safely parked on our premises at S\u00fcdring 10 while you head to check-in relaxed.',
  },
  faqPage: {
    breadcrumbHome: 'Home',
    breadcrumbFaq: 'FAQ',
    title: 'How can we help?',
    subtitle: 'Answers about the process, security and prices for your valet parking at Frankfurt Airport.',
    searchPlaceholder: "Search for 'night surcharge' or 'insurance'...",
    noResults: 'No results found for your search.',
    categoryAll: 'General',
    categoryBookingPrices: 'Booking & Prices',
    categorySecurity: 'Security',
    categoryProcess: 'Process',
    faq1Question: 'How are the parking fees structured?',
    faq1Answer: 'Our prices: 1-8 days cost a flat rate of \u20ac99. From 9 days, the current daily rate applies. Please note possible surcharges for night trips or additional services, which are displayed transparently during the booking process.',
    faq2Question: 'When does the night surcharge apply?',
    faq2Answer: 'A flat night surcharge of \u20ac80.00 is charged when the vehicle handover or return takes place outside our core hours (07:00 \u2013 17:00). This covers the additional personnel costs at night.',
    faq3Question: 'Can I cancel my booking?',
    faq3Answer: 'Yes. If you have booked our cancellation protection (\u20ac5.00), cancellation is free of charge until shortly before arrival. Otherwise, our regular terms and conditions with corresponding cancellation fees apply.',
    faq4Question: 'How does the vehicle handover at the terminal work?',
    faq4Answer: 'You drive directly to the agreed terminal at Frankfurt Airport. Our staff member (identifiable by Park-Box Frankfurt clothing) will be waiting for you, create a digital handover protocol and take over your vehicle. You can go directly to check-in.',
    faq5Question: 'Where exactly is my car parked?',
    faq5Answer: 'Your vehicle is parked on our privately rented parking spaces at S\u00fcdring 10, Hattersheim. It is a fixed, paved parking space on private property, not on public roads.',
    faq6Question: 'Is my vehicle insured?',
    faq6Answer: 'Of course. During the entire time in the care of Park-Box Frankfurt, your vehicle is insured according to legal regulations. The condition is also documented in detail during the handover to avoid misunderstandings.',
    securityBadge: 'Security',
    securityTitle: '24/7 surveillance in Hattersheim',
    staffBadge: 'Staff',
    staffTitle: 'Trained drivers',
    moreThanParking: 'More than just parking',
    moreThanParkingDesc: 'Discover our additional services for maximum comfort.',
    serviceCharging: 'EV charging',
    serviceInsured: 'Insured',
    contactTitle: "Didn't find the right answer?",
    contactDesc: 'Our team in Frankfurt is happy to assist you personally. We usually respond within a few hours.',
    writeEmail: 'Write an email',
    callCustomerService: 'Customer service',
  },
  agbPage: {
    breadcrumbHome: 'Home',
    breadcrumbAgb: 'Terms & Conditions',
    title: 'General Terms and Conditions',
    disclaimer: 'The following applies to all links on our website: We expressly distance ourselves from the content and assume no liability for the content of the pages to which our website links.',
    section1Title: '\u00a7 1 General',
    section1Text1: 'All services offered by Parkboxfrankfurt.com are subject to the following General Terms and Conditions. The version valid at the time of the conclusion of the contract shall apply. By making a booking (offer), but no later than upon conclusion of the contract with Park-Box-Frankfurt.com, the customer declares their agreement to the terms and conditions of Park-Box-Frankfurt.com, which the customer can view on the Internet. Deviating provisions, including those contained in the contractual partner\'s general terms and conditions, shall not apply unless expressly acknowledged in writing by Park-Box-Frankfurt.com.',
    section1Text2: 'The contract is concluded through the customer\'s offer and the confirmation or acceptance of the offer by Parkboxfrankfurt.com. This usually takes place within 12 hours of the reservation request. The customer is obligated to immediately check the reservation confirmation for errors or other defects and to immediately notify Parkboxfrankfurt.com of any incorrect information.',
    section1Text3: 'An offer by the customer can be made in the following ways: booking requests via the homepage Parkboxfrankfurt.com, telephone inquiry or by email.',
    section1Text4: 'Submitting the booking with all required data to Parkboxfrankfurt.com constitutes a binding offer to conclude a contract. If a third party has made the booking, they shall be jointly and severally liable alongside the actual customer for all contractual obligations of the customer.',
    section1Text5: 'Claims arising from the contractual relationship belong exclusively to the customer and are only transferable to a third party with the consent of Parkboxfrankfurt.com.',
    section2Title: '\u00a7 2 Scope of Application',
    section2Text1: 'These General Terms and Conditions apply to all services offered within the framework of the contract with Parkboxfrankfurt.com, such as the rental of a parking space for motor vehicles, as well as all other services provided on behalf of and for the customer.',
    section3Title: '\u00a7 3 Subject of the Contract',
    section3Text1: 'Parkboxfrankfurt.com is obligated to keep the services booked by the customer available within the framework of these terms and conditions and to provide the agreed services. The subject of the contract includes the rental of a parking space for motor vehicles under the conditions stated herein and any other additional services agreed in writing.',
    section3Text2: 'Parkboxfrankfurt.com assumes no custody or special duty of care for items brought in by the tenant. Staying on the business premises is not permitted for tenants. By confirming the reservation, the customer acquires the right to park their car in a parking space on the business premises during the booked period.',
    section3Text3: 'For existing claims arising from the rental agreement, Parkboxfrankfurt.com has a statutory lien on the parked vehicle including the corresponding accessories. Parkboxfrankfurt.com is also entitled to have the parked vehicles removed from the business premises at the expense and risk of the respective tenant, for example if:',
    section3List1: 'the rental agreement has ended and the tenant is unreachable',
    section3List2: 'a parked vehicle poses a general hazard due to defects (e.g., leaking tank, etc.)',
    section3List3: 'a parked vehicle is not officially registered or is taken out of traffic by the authorities during the contract period',
    section3List4: 'the vehicle was parked without authorization',
    section3Text4: 'The tenant is liable for a parked vehicle in case of oil or other fluid leaks and all resulting contamination. Every customer and persons authorized by them must behave in such a way that endangerment and damage to third parties are excluded.',
    section3Text5: 'In the event of damage to the business premises or its facilities, the resulting costs will be invoiced to the customer after the damage has been repaired. In these cases, the customer has no right to self-remedy.',
    section4Title: '\u00a7 4 Fees & Payment',
    section4Text1: 'The current price lists at the time of the conclusion of the contract, which can be viewed on the Internet, apply for price calculation. Time specifications for parking services are calculated based on started calendar days from the time of entry into the parking area, with the arrival and departure day from the business premises being calculated as a full day.',
    section4Text2: 'Parkboxfrankfurt.com is entitled to use a different breakdown or calculation without prior notice. The reservation confirmation includes the final fee for the promised service, unless the customer exceeds the booking time or requests additional paid services that were not known at the time of confirmation.',
    section4Text3: 'The fee for the booked parking space and other services is paid in advance (bank transfer or PayPal) or at the latest upon handover in cash. In the case of electronic payment, the customer expressly grants permission to their bank, in the event of a non-debitable claim, to provide Parkboxfrankfurt.com or a person authorized by them with the customer\'s address and any further information useful for settling the claim.',
    section4Text4: 'With electronic payment, the customer expressly acknowledges the rights and obligations arising from participation in the direct debit procedure with their PIN, even without their signature. Prices include the applicable statutory VAT.',
    section4Text5: 'Parkboxfrankfurt.com may refuse to release the parked vehicle until the invoice price has been paid in full.',
    section5Title: '\u00a7 5 Withdrawal and Cancellation Conditions',
    section5Text1: 'Park Box Frankfurt, proprietor Dina Magdalena Havelka, grants the customer a right of withdrawal at any time. In the event of withdrawal at least 24 hours before the specified arrival time on the business premises, no cancellation fees will be charged. In the event of withdrawal less than 24 hours before, Park Box Frankfurt, proprietor Dina Magdalena Havelka, is entitled to reasonable compensation, which may include either a specifically calculated compensation or a cancellation flat rate of 50% of the agreed price.',
    section5Text2: 'A mutual withdrawal for good cause remains unaffected by this. This applies in cases of force majeure, significant deterioration of assets since the conclusion of the contract or the opening or application for insolvency proceedings over the assets of one of the contracting parties, as well as in the case of justified concern on the part of Park Box Frankfurt, proprietor Dina Magdalena Havelka, that the customer\'s use of the booked services would endanger the operational safety or reputation of the company.',
    section5Text3: 'The party exercising this right of termination for good cause must immediately notify the other party in writing before exercising the right of termination. A claim for damages is excluded in these cases.',
    section5Text4: 'The parking provider may withdraw from the contract up to 24 hours before the vehicle handover date for important reasons. Important reasons include, for example: system errors, overbooking by parking intermediaries, or official orders prohibiting the use of parking spaces.',
    section6Title: '\u00a7 6 Liability / Exclusion of Liability / Business Liability Insurance',
    section6Text1: 'Parkboxfrankfurt.com is liable for all damages caused by it or its employees through fault on the basis of statutory liability provisions (intent and gross negligence) through its business liability insurance.',
    section6Text2: 'In the case of slight negligence, liability for damages only arises if it is attributable to a violation of a material contractual obligation in a manner that jeopardizes the purpose of the contract. In these cases, liability is limited to foreseeable, contract-typical damages.',
    section6Text3: 'Likewise, the customer releases Parkboxfrankfurt.com from liability for damages caused by force majeure (e.g., storm damage, hail, lightning strikes, flooding, etc.) as well as damages caused by internal and external political unrest, acts of war and vandalism, glass damage caused by stone chips, tire & rim damage caused by curbs or other objects.',
    section6Text4: 'A customer\'s claim for reduction or damages shall lapse if the customer has not immediately reported the damage to the supervisory personnel for the purpose of damage assessment before returning the vehicle.',
    section6Text5: 'Parkboxfrankfurt.com is not liable for damage to and destruction of motor vehicles, including their contents and cargo, caused by the actions of third parties, e.g., by other tenants or other persons or animals. This also applies to theft and loss of motor vehicles, vehicle parts, vehicle contents and vehicle cargo (e.g., car radio, navigation, car phone, personal valuables, computer, photography equipment, sports equipment and the like).',
    section6Text6: 'Damages must be reported to staff immediately. The timeliness of arrival is not a subject of the contract. This is the customer\'s responsibility. Claims for damages, particularly those arising from missed flights and other missed appointments, are excluded. Claims are also excluded if the booked services are not used due to late arrival by the customer.',
    section6Text7: 'For the offered "pick-up and delivery service" of the car to and from the terminal, the customer\'s vehicle is covered by our liability insurance during the transfer to/from the parking lot.',
    section6Text8: 'Parkboxfrankfurt.com assumes no liability for possible tire & rim damage, glass damage (stone chips), timing belts, engine or gearbox damage or other technical damage that could occur to the vehicle, or consequential damage arising from any of the aforementioned damages.',
    section6Text9: 'The above limitations of liability apply to all claims for damages regardless of their legal basis, including claims from unlawful acts. The above limitations of liability also apply in cases of possible claims for damages by a customer against employees or vicarious agents of Parkboxfrankfurt.com.',
    section7Title: '\u00a7 7 Flight Rescheduling & Rebooking',
    section7Text1: 'If your flight number or the date of your return flight changes/is rescheduled, you must independently contact us via the specified phone number by SMS/WHATSAPP or by email 24 hours before the actual return flight.',
    section7Text2: 'The parking operator reserves the right to charge a compensation fee of EUR 35 if he is not informed of such a change/rescheduling in time and his driver waits at the airport in vain.',
    section7Important: 'Important:',
    section7ImportantText: 'Customer vehicles are brought to the underground garages in front of the terminals for self-collection where our customers land, if they land in Frankfurt am Main outside our business hours (7:00 AM to 5:00 PM) or their parking time with us has expired!',
    section7OutsideHours: 'outside our business hours',
    section7Text3: 'Our customers receive pickup instructions via all communication channels available to us (SMS/WhatsApp and email).',
    section8Title: '\u00a7 8 Data Protection',
    section8Text1: 'The data provided is protected by Parkboxfrankfurt.com in accordance with the Federal Data Protection Act. The customer agrees that their data will be electronically processed and stored by Parkboxfrankfurt.com within the framework of the contractual relationship. The data will not be passed on to third parties without authorization.',
    section8Text2: 'Changes or additions to the contract require written form. Verbal agreements or unilateral changes or additions by either contracting party are invalid. Should one or more provisions of this contract prove to be invalid under applicable law, the invalid provision shall be replaced by a valid, legally compliant provision that comes closest to the intent of the original provision. The remaining provisions shall remain unaffected. This contract is subject to German law. The place of jurisdiction is Frankfurt am Main.',
    companyLabel: 'Company:',
    ownerLabel: 'Proprietor Dina Magdalena Havelka',
    asOf: 'As of 18.05.2022',
    validityNote: 'With the date of issuance of these General Terms and Conditions, all previously used General Terms and Conditions (GTC) for Parkboxfrankfurt.com shall lose their validity.',
  },
  datenschutzPage: {
    breadcrumbHome: 'Home',
    breadcrumbDatenschutz: 'Privacy Policy',
    title: 'Privacy Policy',
    privacyTitle: 'Your privacy is important to us',
    privacyText: 'We do not use cookies or any other tracking on our website.',
    description: 'At Park-Box Frankfurt, we place great importance on the protection of your personal data. We only collect the data necessary for booking and do not share it with third parties.',
  },
  impressumPage: {
    breadcrumbHome: 'Home',
    breadcrumbImpressum: 'Imprint',
    title: 'Imprint',
    responsiblePerson: 'Responsible for content (according to \u00a7 10 paragraph 3 MDStV):',
    businessSeat: '(Business seat)',
    vatIdLabel: 'VAT ID:',
    parkingAddressTitle: 'Parking Address',
    insuredValet: 'Insured valet parking!',
  },
  common: {
    day: 'day',
    days: 'days',
    clock: '',
    from: 'from',
    to: 'to',
    yes: 'Yes',
    no: 'No',
    none: 'None',
    loading: 'Loading...',
    error: 'Error',
  },
}
